module.exports = angular.module('cartographer.plugin.layer.standard', [])

_ = require 'underscore'

module.exports.run $DI (crtLayer, stdActivityDiaryLayer, stdInvasiveSpeciesSightingLayer) ->
  crtLayer.registerPlugin(stdActivityDiaryLayer)
  crtLayer.registerPlugin(stdInvasiveSpeciesSightingLayer)
  return

module.exports.factory "stdActivityDiaryLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
  stdActivityType
) ->
  crtFeatureLayer.create({
    id: "StdActivityDiary"
    name: "Activity Diary"
    atlasMapId: "StdActivityDiary"
    defaultMapEngine: "atlas"
    selectionRadius: 500
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("Activities", "Activities", [
        crtAttributeLayer.createEnumLookup("activityType", "Activity Type", null, stdActivityType)
        crtAttributeLayer.createAutoThreshold("duration", "Duration", "mins")
      ])
    ]
  })

module.exports.factory "stdInvasiveSpeciesSightingLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
  stdInvasiveSpecies
  stdInvasiveSpeciesAmount
  stdInvasiveSpeciesTreatment
) ->
  crtFeatureLayer.create({
    id: "StdInvasiveSpeciesSighting"
    name: "Invasive Species"
    atlasMapId: "StdInvasiveSpeciesSighting"
    defaultMapEngine: "atlas"
    selectionRadius: 500
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("Species", "Species", [
        crtAttributeLayer.createEnumLookup("species", "Species", null, stdInvasiveSpecies)
        crtAttributeLayer.createEnumLookup("amount", "Amount", null, stdInvasiveSpeciesAmount)
        crtAttributeLayer.createEnumLookup("treatment", "Treatment", null, stdInvasiveSpeciesTreatment)
      ])
    ]
  })
